import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class NotificationItemsResponseDto {
    @IsNumber()
    timestamp: number;

    @ValidateNested({each : true})
    @Type(() => NotificationMessageDto)
    messages: NotificationMessageDto[];
}

export class NotificationMessageDto {
    @IsNumber()
    id: number;

    @IsOptional()
    @IsString()
    Identifier?: string;

    @IsOptional()
    @IsString()
    identifier?: string;

    @IsOptional()
    @IsNumber()
    placementId?: number;

    @IsNumber()
    machineId: number;

    @IsString()
    title: string;

    @IsString()
    body: string;

    @IsBoolean()
    isRead: boolean;

    @IsNumber()
    createdAt: number;
}
